import {createStore, useStore} from 'zustand'

import type {CreatableBlockType} from '../../../../utils'
import type {Edge} from '@atlaskit/pragmatic-drag-and-drop-hitbox/types'

export interface CreateBlockMeta {
  blockType: CreatableBlockType
  needleBlockId?: string
  panelId: string
  position: Edge
  pullout: boolean
}

export interface CreateBlockDialogState {
  meta?: CreateBlockMeta
  openDialog: (meta: Omit<CreateBlockMeta, 'pullout'>) => void
  closeDialog: () => void
  togglePullout: () => void
  loading: boolean
}

// We use a vanilla store here, so we can easily dispatch changes form drag-and-drop monitors
// We then create the store hook for usage in components
// https://docs.pmnd.rs/zustand/guides/typescript#bounded-usestore-hook-for-vanilla-stores
export const createBlockDialogStore = createStore<CreateBlockDialogState>()((set) => ({
  meta: undefined,
  openDialog: (info: Omit<CreateBlockMeta, 'pullout'>) => set((state) => ({
    ...state,
    meta: {
      ...info,
      pullout: false,
    },
  })),
  closeDialog: () => set((state) => ({...state, meta: undefined})),
  togglePullout: () => set((state) => {
    if (!state.meta) {
      return state
    }
    return {
      ...state,
      meta: {
        ...state.meta,
        pullout: !state.meta.pullout,
      },
    }
  }),
  loading: false,
}))

export function useCreateBlockDialogStore<T>(selector?: (state: CreateBlockDialogState) => T) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return useStore(createBlockDialogStore, selector!)
}
